import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'ark-confirmation-message',
  templateUrl: './confirmation-message.component.html',
  styleUrls: ['./confirmation-message.component.scss']
})
export class ConfirmationMessageComponent implements OnInit {

  message = '';
  label = 'Cancel';
  obj = {};

  constructor(
    public dialogRef: MatDialogRef<ConfirmationMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.message = this.data.message;
    if (this.data.label) {
      this.label = this.data.label;
    }
  }

  close() {
    this.dialogRef.close();
  }

  ok() {
    this.obj = {ok:true};
    this.dialogRef.close(this.obj);
  }

}
